export default () => ({
  standingOrders: [],
});
